export const getSharedFilters = (defaultFilters, namespace = 'global_geo_filters') => {
  try {
    const saved = sessionStorage.getItem(namespace);
    if (saved) {
      const parsed = JSON.parse(saved);
      const merged = { ...defaultFilters };
      Object.keys(defaultFilters).forEach(key => {
        if (parsed[key] !== undefined) {
          // 如果传过来的是一个数组，并且只有一个值，且这个值包含“全部”，我们就认为它是默认的“ALL”状态
          // 此时我们使用当前组件的 defaultAll（即 defaultFilters[key]），而不是其他页面的字符串（比如“全部AI引擎”或“全部平台”）
          if (Array.isArray(parsed[key]) && parsed[key].length === 1 && typeof parsed[key][0] === 'string' && parsed[key][0].includes('全部')) {
            merged[key] = defaultFilters[key];
          } else {
            merged[key] = parsed[key];
          }
        }
      });
      return merged;
    }
  } catch (e) {
    console.error('Failed to parse shared filters', e);
  }
  return defaultFilters;
};

export const saveSharedFilters = (filters, namespace = 'global_geo_filters') => {
  try {
    const saved = sessionStorage.getItem(namespace);
    let current = {};
    if (saved) {
      current = JSON.parse(saved);
    }
    const merged = { ...current, ...filters };
    sessionStorage.setItem(namespace, JSON.stringify(merged));
  } catch (e) {
    console.error('Failed to save shared filters', e);
  }
};
